import React, { useEffect, useState } from 'react';
//import { CrearLinkPagoPayPhone } from 'utils/Query';
import Pagos from "../../../assets/imagen/pagosmedios.jpeg"
let Dunas = "https://www.deuna.uanataca.ec/assets/images/deunalogo.png"
import { GenerarLinkPagoMedios, EnviarmensajeWhastapp } from 'utils/Query';
import { LimpiarLocalStore, Limpiarseleccion, LimpiarDescuentoVenta } from '../../../utils/CarritoLocalStorang';
import { getDatosUsuariosLocalStorag } from 'utils/DatosUsuarioLocalStorag';
import { GetMetodo, GetValores } from '../../../utils/CarritoLocalStorang';
import { Modal, Spinner } from 'react-bootstrap';
import { clearMapa } from 'StoreRedux/Slice/mapaLocalSlice';
import { borrarseleccion } from 'StoreRedux/Slice/sillasSlice';
import { useDispatch, useSelector } from "react-redux"
import { setModal } from 'StoreRedux/Slice/SuscritorSlice';
import SweetAlert from 'react-bootstrap-sweetalert';
import { PagoRapido } from 'utils/Querycomnet';
import ReactGA from 'react-ga4';
import { clienteInfo } from 'utils/DatosUsuarioLocalStorag';
import { bancos } from 'utils/Imgenesutils';
import { setToastes } from 'StoreRedux/Slice/ToastSlice';
import { Metodos, ComisionesPago } from 'utils/constantes';
import { logWithCallback } from 'utilsstile.js/style';
import { ListarMetodosPagoActivos } from 'utils/ConfiguracionPagosQuery';
import { ListarDescuentosVendedor, InfoDescuentoLink } from 'utils/DescuentosEventoQuery';
import { textoDescuento } from 'utils/descuentoTexto';
import SeccionFisicosVenta, { useBoletosFisicosVenta } from 'views/Components/BoletosFisicos/SeccionFisicosVenta';
let { atencion, diners, visas, paypal } = bancos

const TRACKING_ID = "G-LJN507B5NX";
function ModalPago(props) {
    useEffect(() => { ReactGA.initialize(TRACKING_ID); }, []);
    const { setModalPago, modalPago, detenervelocidad, intervalo } = props
    let usedispatch = useDispatch();
    const [gatewayElegido, setGatewayElegido] = useState(null)
    const [gatewaysActivos, setGatewaysActivos] = useState(null)
    // Duna solo devuelve una cosa por pago: o un QR (imagen, para escanear) o un
    // link (para compartir/copiar), nunca los dos. Antes se elegia solo, en base
    // al dispositivo (esMovil()); ahora en el panel admin (vender entrada) se le
    // deja elegir a quien vende, para poder copiar el link en vez de quedar
    // atado a un QR. Arranca con el mismo valor que antes por defecto.
    const [dunaModo, setDunaModo] = useState(esMovil() ? 'link' : 'qr')
    let metodo = gatewayElegido || GetMetodo()
    useEffect(() => {
        // Antes solo se pedia esto cuando metodo === "Tarjeta", asi que si el
        // usuario entraba con otro metodo (Efectivo-Local, Duna, etc.) nunca se
        // refrescaba sessionStorage[ComisionesPago] en este componente, y
        // GetValores() se quedaba con lo que hubiera de una carga anterior (o
        // nada). Ahora se pide una sola vez apenas se abre el modal, sin
        // importar el metodo, para que el % configurado (global o por evento)
        // siempre este disponible.
        if (gatewaysActivos === null) {
            const codigoEvento = JSON.parse(sessionStorage.getItem("infoevento") || "{}")?.codigoEvento
            ListarMetodosPagoActivos(codigoEvento).then((resp) => {
                const activos = Array.isArray(resp?.data) ? resp.data.filter((g) => g.activo).map((g) => g.metodo) : []
                setGatewaysActivos(activos)
                if (Array.isArray(resp?.data)) sessionStorage.setItem(ComisionesPago, JSON.stringify(resp.data))
            }).catch(() => setGatewaysActivos([]))
        }
    }, [])
    function elegirGateway(m) {
        sessionStorage.setItem(Metodos, m)
        setGatewayElegido(m)
    }

    /* Descuentos (%) que ESTE vendedor puede aplicar a esta venta (uno por
       venta). Solo aplica cuando hay un operador logueado (panel interno);
       en la tienda publica clienteInfo() es null y no se muestra nada.
       El id elegido se deja en sessionStorage: PagoRapido arma el payload
       desde ahi y el backend revalida/recalcula. */
    const [descuentosVend, setDescuentosVend] = useState([])
    const [descuentoSelId, setDescuentoSelId] = useState(null)
    // Descuento por link publico (?desc=CODIGO en la tienda) ya validado y
    // guardado por Flasdeticket en sessionStorage. Aca solo se muestra.
    const descLinkPublico = (() => {
        try { return JSON.parse(sessionStorage.getItem("descuentoLinkPublico") || "null") } catch (_e) { return null }
    })()
    // Al abrir el checkout ya se conoce la cedula del comprador: se revalida
    // el link con ella (tope por cedula + tope global, que pudo llenarse
    // desde que se abrio la tienda). Si ya no aplica se quita, para que el
    // total que ve el cliente sea el que realmente se le va a cobrar.
    const [, setRevalidacionDescuento] = useState(0)
    useEffect(() => {
        const codigo = descLinkPublico?.codigo
        if (!codigo) return
        let cedula = ""
        try { cedula = getDatosUsuariosLocalStorag()?.cedula || "" } catch (_e) { /* sin datos */ }
        InfoDescuentoLink(codigo, cedula).then((resp) => {
            const info = resp?.data
            if (resp?.success && info?.valido) return
            LimpiarDescuentoVenta()
            setRevalidacionDescuento((n) => n + 1)
            usedispatch(setToastes({
                show: true,
                message: info?.motivo || 'El descuento del link ya no es válido',
                color: 'bg-warning',
                estado: 'Descuento no aplicado'
            }))
        }).catch(() => { /* si falla la red, el backend igual valida al registrar */ })
    }, [])
    useEffect(() => {
        const user = clienteInfo()
        if (!user || !user.id) { setDescuentosVend([]); return }
        // Una seleccion de vendedor previa (ej. elegida en la pagina de venta
        // del panel, Ventas/index.js) se CONSERVA si sigue siendo uno de los
        // descuentos de este usuario para este evento; si no, se limpia (era
        // de otra venta/evento). NO toca un descuento por link publico ({codigo}).
        let prev = null
        try { prev = JSON.parse(sessionStorage.getItem("descuentoVentaSel") || "null") } catch (_e) { /* noop */ }
        const prevIdVendedor = prev && prev.id && !prev.codigo ? prev.id : null
        const codigoEvento = JSON.parse(sessionStorage.getItem("infoevento") || "{}")?.codigoEvento
        if (!codigoEvento) {
            if (prevIdVendedor) sessionStorage.removeItem("descuentoVentaSel")
            return
        }
        ListarDescuentosVendedor(codigoEvento, user.id)
            .then((resp) => {
                const lista = Array.isArray(resp?.data) ? resp.data : []
                setDescuentosVend(lista)
                if (!prevIdVendedor) return
                if (lista.some((d) => d.id === prevIdVendedor)) setDescuentoSelId(prevIdVendedor)
                else sessionStorage.removeItem("descuentoVentaSel")
            })
            .catch(() => {
                setDescuentosVend([])
                if (prevIdVendedor) sessionStorage.removeItem("descuentoVentaSel")
            })
    }, [])
    function elegirDescuento(id) {
        setDescuentoSelId(id)
        if (id) {
            const elegido = descuentosVend.find((d) => d.id === id)
            // Se guarda el detalle completo (no solo el id): GetValores()
            // necesita saber si este tipo de descuento va sobre el precio
            // BASE o el FINAL (aplica_sobre) para reducir el precio ANTES de
            // IVA/comision bancaria cuando corresponde -- antes esto solo se
            // guardaba como {id}, así que un descuento "sobre precio base"
            // elegido por un vendedor nunca reducia nada aca, y el backend
            // (que confia en que el frontend ya lo hizo en ese modo) tampoco
            // lo aplicaba: el cliente terminaba pagando el total bruto,
            // sin descuento real, aunque el aviso mostrara uno.
            sessionStorage.setItem("descuentoVentaSel", JSON.stringify({
                id,
                porcentaje: elegido ? Number(elegido.porcentaje) : 0,
                aplica_sobre: elegido?.aplica_sobre === "base" ? "base" : "final",
            }))
        } else {
            sessionStorage.removeItem("descuentoVentaSel")
        }
    }
    const descuentoVendSel = descuentosVend.find((d) => d.id === descuentoSelId) || null
    // GetValores() ya resuelve el descuento activo -- vendedor o link, y su
    // modo base/final (ver obtenerDescuentoActivo en CarritoLocalStorang.js)
    // -- asi que aca solo se decide SI mostrar el aviso; el numero sale
    // siempre de ahi, para no duplicar la formula (y no volver a ignorar
    // aplica_sobre como pasaba antes).
    const totalConDescuentoTxt = (() => {
        const pctActivo = descuentoVendSel ? Number(descuentoVendSel.porcentaje) : (descLinkPublico ? (descLinkPublico.tipo_descuento === 'monto' ? Number(descLinkPublico.monto_descuento) : Number(descLinkPublico.porcentaje)) : 0)
        if (!pctActivo) return null
        const neto = parseFloat(GetValores()?.total_con_descuento || 0)
        return neto ? neto.toFixed(2) : null
    })()
    const [spinerst, setSpiner] = useState("d-none")
    // Boletos fisicos entregados en la venta (solo personal): se asignan cuando la compra ya tiene id
    const fisicos = useBoletosFisicosVenta()
    const asignarFisicos = (ouput) => {
        if (ouput && ouput.success && (ouput.idRegistro || ouput.id)) fisicos.asignar(ouput.idRegistro || ouput.id).then((res) => { if (res) usedispatch(setToastes({ show: true, message: res.texto, color: res.ok ? 'bg-success' : 'bg-warning', estado: 'Boletos físicos' })) })
    }
    const [alert, setAlert] = useState(null)
    const [cargar, setCargar] = useState(false)
    const [datosPerson, setPerson] = useState({
        cedula: '',
        name: '',
        email: '',
        whatsapp: '',
        metodoPago: '',
        envio: '',
        direccion: '',
    })
    useEffect(() => {
        let datosPersonal = getDatosUsuariosLocalStorag()
        if (datosPersonal !== null) {
            setPerson({
                ...datosPerson,
                direccion: datosPersonal.direccion,
                email: datosPersonal.email,
                name: datosPersonal.name,
                whatsapp: datosPersonal.whatsapp,
                envio: datosPersonal.envio,
                cedula: datosPersonal.cedula,
            })
        }
        setCargar(!cargar)
        /*$(document).ready(function () {
            $(".modal-content").draggable({
                handle: ".modal-header"
                ,
                containment: "#root",
            })
        })*/
    }, [modalPago])

    const closedeposito = () => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}


                closeOnClickOutside={false}
                showCancel={false}
                showConfirm={false}
                closeAnim={{ name: 'hideSweetAlert', duration: 500 }}

            >
                <div >
                    <div className='col-12 pb-3'>
                        <img src={atencion} className="img-fluid"
                            style={{
                                height: 100
                            }}
                        ></img>
                    </div>
                    <div>
                        <h6 className=' col-9 col-md-12  mx-auto' style={{
                            fontWeight: "bold",
                            fontSize: "1.0rem"
                        }}>¿Quieres abandonar tu proceso de compra?</h6>
                        <p> No puedes guardar tu proceso y continuar luego. Si, abandonas perderás tus reservas
                        </p>
                        <p>  </p>
                    </div>


                </div>
                <div className='d-flex  justify-content-around py-4'>
                    <div>
                        <button className='btn btn-outline-danger  rounded-6' onClick={() => borrar()}>

                            <span style={{
                                fontWeight: "bold"
                            }}>Anular Compra</span>
                        </button>
                    </div>
                    <div>
                        <button className=' btn btn-warning rounded-5' onClick={() => hideAlert()} >
                            <span style={{
                                fontWeight: "bold"
                            }}> Completar Compra</span>
                        </button>
                    </div>

                </div>

            </SweetAlert>
        )
    }
    const borrar = () => {


        detenervelocidad()
        // BUG FIX: estaban comentadas -- el dialogo de "Anular Compra" le
        // avisa al usuario "si abandonas perderás tus reservas", pero sin
        // estas dos llamadas el carrito y la seleccion de asientos en
        // sessionStorage/memoria NUNCA se limpiaban de verdad al confirmar.
        Limpiarseleccion()
        LimpiarLocalStore()
        usedispatch(clearMapa({}))
        usedispatch(borrarseleccion({ estado: "seleccionado" }))
        setModalPago(false)
        hideAlert()
    }
    const succesAlert = () => {
        setAlert(
            <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Estas seguro de cancelar la compra"
                onConfirm={() => hideAlert()}
                onCancel={() => borrar()}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                confirmBtnText="Continuar"
                cancelBtnText="Salir y Borrar"
                closeOnClickOutside={false}
                closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
                showCancel
            >
                Se borraran todos los datos Seleccionados
            </SweetAlert>
        )
    }
    function esMovil() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    // Abre el checkout de una pasarela que NO se puede embeber en el iframe del
    // modal 'pago' (PagoPlux, Stripe, PayPal mandan X-Frame-Options). Antes se
    // hacia solo `window.open(url, '_blank')` dentro del .then de PagoRapido:
    // como no viene de un tap directo del usuario, los navegadores moviles
    // bloquean ese popup y el comprador se quedaba sin nada (modal cerrado y
    // carrito limpiado). Ahora se intenta abrir la pestana y, pase lo que pase,
    // se deja un dialogo con un enlace real para tocar (eso si cuenta como gesto
    // de usuario) y opciones de reintentar / copiar el link.
    function abrirLinkPasarela(url, nombrePasarela) {
        if (!url) {
            usedispatch(setToastes({
                show: true,
                message: "No se recibió el link de pago, intenta de nuevo",
                color: 'bg-danger',
                estado: "Hubo un error"
            }))
            return
        }
        let ventana = null
        try { ventana = window.open(url, '_blank') } catch (e) { ventana = null }
        const seAbrio = !!ventana && !ventana.closed

        const contenido = `
    <div style="text-align:center;padding:10px;">
        <p style="color:#333;font-size:1.05em;margin-bottom:15px;font-weight:500;">
            ${seAbrio
                ? 'Abrimos el pago de ' + nombrePasarela + ' en otra pesta&ntilde;a. Si no la ves, toca el bot&oacute;n:'
                : 'Toca el bot&oacute;n para pagar con ' + nombrePasarela + ':'}
        </p>
        <a href="${url}" target="_blank" rel="noopener"
            style="display:inline-block;text-decoration:none;padding:14px 28px;border:2px solid #007bff;border-radius:12px;background-color:#f0f8ff;font-weight:bold;color:#0056b3;box-shadow:0 4px 8px rgba(0,0,0,0.1);">
            Ir a pagar con ${nombrePasarela}
        </a>
        <p style="font-size:0.85em;color:#888;margin-top:18px;">
            Tu compra queda <b>pendiente</b>: tambi&eacute;n puedes completarla luego desde
            <b>Tickets &rarr; Reportar Compras</b>.
        </p>
    </div>`

        $.confirm({
            title: 'Pagar con ' + nombrePasarela,
            content: contenido,
            type: 'blue',
            icon: 'fas fa-credit-card',
            closeIcon: true,
            animation: 'zoom',
            closeAnimation: 'scale',
            buttons: {
                abrir: {
                    text: 'Abrir de nuevo',
                    btnClass: 'btn-primary',
                    action: function () { window.open(url, '_blank') }
                },
                copiar: {
                    text: 'Copiar link',
                    btnClass: 'btn-default',
                    action: function () {
                        try { navigator.clipboard.writeText(url) } catch (e) { }
                        usedispatch(setToastes({ show: true, message: 'Link copiado', color: 'bg-success', estado: 'Copiado' }))
                        return false
                    }
                },
                cerrar: {
                    text: 'Cerrar',
                    btnClass: 'btn-default',
                    action: function () { }
                }
            },
            backgroundDismiss: true,
        })
    }
    const hideAlert = () => {
        setAlert(null)
    }
    function validarDatosComprador() {
        const datos = getDatosUsuariosLocalStorag()
        if (!datos) return ["Completa tus datos personales antes de continuar"]
        const faltantes = []
        const esAdmin = clienteInfo() != null
        if (!datos.cedula || String(datos.cedula).trim().length < 4) faltantes.push("Cédula")
        const nameValue = datos.name || datos.nombreCompleto || ''
        if (!nameValue || String(nameValue).trim().length < 2) faltantes.push("Nombre completo")
        const emailValido = datos.email && String(datos.email).includes("@") && String(datos.email).trim() !== "null"
        if (!emailValido) faltantes.push("Correo electrónico")
        if (!esAdmin && (!datos.whatsapp || String(datos.whatsapp).trim().length < 7)) faltantes.push("Número de teléfono")
        return faltantes
    }

    function CrearPagoMedio() {
        const faltantes = validarDatosComprador()
        if (faltantes.length > 0) {
            usedispatch(setToastes({
                show: true,
                message: "Faltan datos requeridos: " + faltantes.join(", "),
                color: 'bg-danger',
                estado: "Completa los datos para generar el link de pago"
            }))
            return
        }
        let user = clienteInfo()
        setSpiner("")
        const opcionesPago = metodo === "Duna" ? { canalOverride: dunaModo === 'qr' ? 'Web' : 'Web Movil' } : {}
        PagoRapido("", opcionesPago).then(ouput => {
            asignarFisicos(ouput)
            if (user == null) {
                if (ouput.success) {

                    logWithCallback(ouput)

                    window.gtag('event', 'begin_checkout', {
                        transaction_id: "T_" + ouput.idRegistro,  // ID único de la transacción
                        value: ouput.valores.subtotal, // Valor total
                        tax: ouput.valores.iva,
                        affiliation: "Pagomedias", // Nombre de la tienda o sitio
                        currency: 'USD', // Moneda                       
                        items: ouput.concierto.map(item => ({
                            item_name: item.localidad_nombre,
                            item_id: item.id_localidad,
                            price: item.localidad_precio,
                            item_list_name: item.nombreConcierto,
                            quantity: item.cantidad,
                            item_category: item.nombreConcierto,
                        }))
                    });


                    window.gtag('event', 'purchase', {
                        transaction_id: "T_" + ouput.idRegistro,  // ID único de la transacción
                        value: ouput.valores.subtotal, // Valor total
                        tax: ouput.valores.iva,
                        affiliation: "Pagomedio", // Nombre de la tienda o sitio
                        currency: 'USD', // Moneda

                        items: ouput.concierto.map(item => ({
                            item_name: item.localidad_nombre,
                            item_id: item.id_localidad,
                            price: item.localidad_precio,
                            item_list_name: item.nombreConcierto,
                            quantity: item.cantidad,
                            item_category: item.nombreConcierto,
                        }))
                    });
                    if (metodo == "Duna") {
                        if (esMovil()) {
                            // Opción 2 (Recomendada): Abrir en una nueva pestaña (para que no pierda tu app)
                           // window.open(ouput.url, '_blank');
                            usedispatch(setModal({ nombre: '', estado: "" }))
                            setSpiner("d-none")
                            LimpiarLocalStore()
                            Limpiarseleccion()
                            LimpiarDescuentoVenta()
                            const botonDunaHTML = `
    <div style="text-align: center; padding: 20px;">
        <p style="color: #333; font-size: 1.1em; margin-bottom: 25px; font-weight: 500;">
            Continúa el pago en tu dispositivo móvil:
        </p>

        <a 
            href="${ouput.url}" 
            target="_blank" 
            style="
                display: inline-block; /* Importante para que el padding y estilos se apliquen */
                text-decoration: none; 
                padding: 15px 30px; /* Hace el botón grande */
                border: 2px solid #007bff; /* Borde azul */
                border-radius: 12px; 
                background-color: #f0f8ff; /* Fondo muy claro */
                box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* Sombra para darle profundidad */
                transition: background-color 0.3s;
            "
            onmouseover="this.style.backgroundColor='#e3f2fd'" /* Efecto hover */
            onmouseout="this.style.backgroundColor='#f0f8ff'"
            title="Abrir app de pago Duna"
        >
            <img 
                src="https://www.deuna.uanataca.ec/assets/images/deunalogo.png" 
                alt="Logo de Deuna" 
                style="
                    max-width: 120px; 
                    height: auto; 
                    display: block; 
                    margin: 0 auto;
                " 
            />
        </a>

        <p style="font-size: 0.9em; color: #888; margin-top: 25px;">
            Se abrirá en una nueva pestaña para que puedas volver fácilmente.
        </p>
    </div>
`;

                            // 2. Llamada a JQuery-Confirm.js para mostrar el botón
                            $.confirm({
                                title: 'Pagar con Duna',
                                content: botonDunaHTML, // Inyecta el HTML con el botón
                                type: 'blue',
                                icon: 'fas fa-mobile-alt',
                                closeIcon: true,
                                animation: 'zoom',
                                closeAnimation: 'scale',
                                // Quitamos los botones de confirm, solo dejamos el icono de cerrar 'x'
                                buttons: {
                                    // Puedes dejar esto vacío o eliminarlo si quieres que solo se cierre con el icono 'x'
                                    // Si lo dejas, solo aparecerá el botón 'Cerrar'
                                    cerrar: {
                                        text: 'Cerrar',
                                        btnClass: 'btn-default',
                                        action: function () { }
                                    }
                                },
                                backgroundDismiss: true,
                            });
                            return
                        }
                        usedispatch(setModal({ nombre: '', estado: "" }))
                        setSpiner("d-none")
                        LimpiarLocalStore()
                        Limpiarseleccion()
                        LimpiarDescuentoVenta()
                        const qrContentHTML = `
    <div style="text-align: center; padding: 10px;">
        <img 
            src="https://www.deuna.uanataca.ec/assets/images/deunalogo.png" 
            alt="Logo de Deuna" 
            style="max-width: 100px; height: auto; margin-bottom: 15px;" 
        />
        <p style="color: #555; font-size: 1.1em; margin-bottom: 20px; font-weight: 400;">
            Escanea para pagar al instante
        </p>
        <img 
            src="${ouput.url}" 
            alt="Código de Pago QR" 
            style="max-width: 90%; height: auto; display: block; margin: 0 auto;" 
        />
    </div>
`;
                        setSpiner("d-none");
                        LimpiarLocalStore();
                        Limpiarseleccion();
                        LimpiarDescuentoVenta();
                        // 1. Limpieza inicial
                        // Si estás en React, mantienes estas llamadas:
                        usedispatch(setModal({ nombre: '', estado: "" }));
                        setSpiner("d-none"); // Oculta el spinner principal
                        LimpiarLocalStore();
                        Limpiarseleccion();
                        LimpiarDescuentoVenta();

                        // 2. Llamada a JQuery-Confirm.js para mostrar el QR
                        $.confirm({
                            title: 'Pago con Duna', // Título del modal
                            content: qrContentHTML, // Inyecta el HTML del QR
                            type: 'blue', // Color del encabezado (opcional: 'green', 'red', 'orange', etc.)
                            icon: 'fas fa-qrcode', // Ícono (si usas Font Awesome)
                            closeIcon: true, // Muestra el botón de cerrar (x)
                            animation: 'zoom', // Animación de apertura (ej: 'opacity', 'zoom', 'scale')
                            closeAnimation: 'scale', // Animación de cierre
                            buttons: {
                                // Solo necesitamos un botón para cerrar
                                cerrar: {
                                    text: 'Cerrar',
                                    btnClass: 'btn-primary',
                                    action: function () {
                                        // Aquí puedes añadir lógica si necesitas hacer algo al cerrar.
                                        // Por ahora, solo cerramos.
                                    }
                                }
                            },
                            // Configuración para permitir cerrar al hacer clic fuera
                            backgroundDismiss: true,
                            // Oculta el título del botón si solo quieres que se vea el icono 'x'
                            // Esto es opcional y depende del estilo de tu aplicación:
                            // closeIconClass: 'fas fa-times' 
                        });

                    }
                    if (metodo == "PagoPlux" || metodo == "Stripe" || metodo == "PayPal") {
                        // El checkout de estas plataformas no se puede embeber en el
                        // iframe del modal 'pago' (X-Frame-Options), asi que se abre
                        // aparte. abrirLinkPasarela intenta el window.open y ademas
                        // muestra un dialogo con un enlace tocable + copiar link, para
                        // que en moviles (donde el popup async se bloquea) el usuario
                        // igual tenga como llegar al pago.
                        usedispatch(setModal({ nombre: '', estado: "" }))
                        setSpiner("d-none")
                        LimpiarLocalStore()
                        Limpiarseleccion()
                        LimpiarDescuentoVenta()
                        abrirLinkPasarela(ouput.url, metodo)
                    } else if (metodo != "Duna") {
                        usedispatch(setModal({ nombre: 'pago', estado: ouput.url }))

                        setSpiner("d-none")
                        LimpiarLocalStore()
                        Limpiarseleccion()
                        LimpiarDescuentoVenta()
                    }

                    //detenervelocidad()
                }
                else {
                    ReactGA.event({
                        category: "error",
                        action: "Pagomedia-error",
                        label: Math.random().toString(36).slice(-10),
                    })
                    usedispatch(setToastes({
                        show: true,
                        message: ouput.descuento_invalido ? `${ouput.message}. Se quitó el descuento, revisa el total e intenta de nuevo.` : ouput.montos_invalidos ? ouput.message : "Lo sentimos la plataforma no género el link  intente más tarde",
                        color: 'bg-primary',
                        estado: "Hubo un error departe de Pagomedio"
                    }))

                    // BUG FIX: esto limpiaba el carrito/seleccion igual que en
                    // el camino exitoso, pero el mensaje invita a reintentar
                    // ("intente más tarde") -- el usuario perdia sus asientos
                    // por una falla de la pasarela/red, sin haber hecho nada
                    // mal, y tenia que volver a elegir todo (con riesgo de que
                    // ya no esten disponibles). El catch de red de mas abajo
                    // ya NO limpia en este mismo caso, esto lo hace consistente.
                    usedispatch(setModal({ nombre: '', estado: "" }))
                    usedispatch(clearMapa())

                    detenervelocidad()
                }
            }
            else {
                if (ouput.success && ouput.url) {
                    popUp(ouput.url)
                    usedispatch(setModal({ nombre: '', estado: "" }))
                } else {
                    usedispatch(setToastes({
                        show: true,
                        message: ouput.descuento_invalido ? `${ouput.message}. Se quitó el descuento, revisa el total e intenta de nuevo.` : ouput.montos_invalidos ? ouput.message : "Lo sentimos la plataforma no género el link  intente más tarde",
                        color: 'bg-danger',
                        estado: "Hubo un error departe de Pagomedio"
                    }))
                }
                setSpiner("d-none")
            }
            // setModalPago(false)
        }).catch(errro => {
            ReactGA.event({
                category: "error",
                action: "Pagomedia-error",
                label: "Pendiente-TC",
            })
            usedispatch(setModal({ nombre: '', estado: "" }))
            usedispatch(setToastes({
                show: true,
                message: "Lo sentimos la platadorma de Pagomedia no genero el link",
                color: 'bg-primary',
                estado: "Hubo un error de Pagomedio"
            }))

            setSpiner("d-none")
        })
        /*const data = await GenerarLinkPagoMedios()

        if (data.status === 200) {

            

        }*/

    }
    function CrearPyhome() {
        const faltantes = validarDatosComprador()
        if (faltantes.length > 0) {
            usedispatch(setToastes({
                show: true,
                message: "Faltan datos requeridos: " + faltantes.join(", "),
                color: 'bg-danger',
                estado: "Completa los datos para generar el link de pago"
            }))
            return
        }
        sessionStorage.setItem(Metodos, "Payphone")
        let user = clienteInfo()

        setSpiner("")
        setTimeout(function () {
            PagoRapido("").then(ouput => {
                asignarFisicos(ouput)

                if (user == null) {
                    if (ouput.success) {
                        window.gtag('event', 'begin_checkout', {
                            transaction_id: "T_" + ouput.idRegistro,  // ID único de la transacción
                            value: ouput.valores.subtotal, // Valor total
                            tax: ouput.valores.iva,
                            affiliation: "Tienda Online", // Nombre de la tienda o sitio
                            currency: 'USD', // Moneda

                            items: ouput.concierto.map(item => ({
                                item_name: item.localidad_nombre,
                                item_id: item.id_localidad,
                                price: item.localidad_precio,
                                item_list_name: item.nombreConcierto,
                                quantity: item.cantidad,
                                item_category: "COMNET"
                            }))
                        });
                        // El checkout de Payphone manda X-Frame-Options: DENY, no se
                        // puede embeber en el iframe del modal 'pago' (se queda en
                        // blanco). abrirLinkPasarela intenta el window.open y ademas
                        // deja un dialogo con enlace tocable + copiar link, para que
                        // en moviles (donde el popup async se bloquea) el usuario
                        // igual pueda llegar al pago.
                        usedispatch(setModal({ nombre: '', estado: "" }))
                        setSpiner("d-none")
                        LimpiarLocalStore()
                        Limpiarseleccion()
                        LimpiarDescuentoVenta()
                        abrirLinkPasarela(ouput.url, "Payphone")

                    }
                    else {
                        usedispatch(setToastes({
                            show: true,
                            message: ouput.descuento_invalido ? `${ouput.message}. Se quitó el descuento, revisa el total e intenta de nuevo.` : ouput.montos_invalidos ? ouput.message : "Lo sentimos la plataforma de Payphome no género el link intente más tarde",
                            color: 'bg-primary',
                            estado: "Hubo un error departe de Pagomedio"
                        }))

                        ReactGA.event({
                            category: "error",
                            action: "Pyhome-error",
                            label: "Pendiente-TC",
                        })
                        // BUG FIX: mismo caso que el bloque de arriba -- no
                        // limpiar el carrito/seleccion en una falla que invita
                        // a reintentar ("intente más tarde").
                        usedispatch(setModal({ nombre: '', estado: "" }))
                        setSpiner("d-none")
                        usedispatch(clearMapa())

                    }
                }
                else {
                    if (ouput.success && ouput.url) {
                        popUp(ouput.url)
                        usedispatch(setModal({ nombre: '', estado: "" }))
                    } else {
                        usedispatch(setToastes({
                            show: true,
                            message: ouput.descuento_invalido ? `${ouput.message}. Se quitó el descuento, revisa el total e intenta de nuevo.` : ouput.montos_invalidos ? ouput.message : "Lo sentimos la plataforma de Payphome no género el link intente más tarde",
                            color: 'bg-danger',
                            estado: "Hubo un error departe de Pagomedio"
                        }))
                    }
                    setSpiner("d-none")
                }
                // setModalPago(false)
            }).catch(errro => {
                ReactGA.event({
                    category: "error",
                    action: "Pyhome-erro",
                    label: "Pendiente-TC",
                })
                usedispatch(setModal({ nombre: '', estado: "" }))
                usedispatch(setToastes({
                    show: true,
                    message: "Lo sentimos la platadorma de Pagomedia no genero el link",
                    color: 'bg-primary',
                    estado: "Hubo un error de Pagomedio"
                }))
                setSpiner("d-none")
            })
        }, 1000)

    }
    function popUp(URL) {
        if (metodo == "Duna" && dunaModo === 'qr') {
            // Elegido "Código QR": el backend devuelve un QR (imagen base64), no un link
            // navegable. window.open con una data: URL lo bloquea el navegador (pestaña en
            // blanco), asi que se muestra el QR embebido para escanear.
            const qrContentHTML = `
    <div style="text-align: center; padding: 10px;">
        <p style="color: #555; font-size: 1.1em; margin-bottom: 20px; font-weight: 400;">
            Escanea para pagar al instante
        </p>
        <img
            src="${URL}"
            alt="Código de Pago QR"
            style="max-width: 90%; height: auto; display: block; margin: 0 auto;"
        />
    </div>
`;
            $.confirm({
                title: 'Pago con Duna',
                content: qrContentHTML,
                type: 'blue',
                icon: 'fas fa-qrcode',
                closeIcon: true,
                animation: 'zoom',
                closeAnimation: 'scale',
                buttons: {
                    cerrar: {
                        text: 'Cerrar',
                        btnClass: 'btn-primary',
                        action: function () { }
                    }
                },
                backgroundDismiss: true,
            });
            usedispatch(setModal({ nombre: '', estado: "" }))
            LimpiarLocalStore()
            Limpiarseleccion()
            LimpiarDescuentoVenta()
            usedispatch(clearMapa())
            detenervelocidad()
            return
        }
        if (metodo == "Duna" && dunaModo === 'link') {
            // Elegido "Link para copiar": el backend devuelve un deeplink real (no un QR),
            // asi que en vez de abrirlo en una ventana nueva se muestra con un boton de
            // copiar, igual que el link de pago de Tarjeta/PagoPlux.
            const linkContentHTML = `
    <div style="text-align: center; padding: 10px;">
        <p style="color: #555; font-size: 1.1em; margin-bottom: 15px; font-weight: 400;">
            Link de pago Deuna
        </p>
        <input id="dunaLinkInput" type="text" readonly value="${URL}"
            style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 6px; font-size: 0.85em; text-align: center;"
            onclick="this.select()" />
    </div>
`;
            $.confirm({
                title: 'Pago con Duna',
                content: linkContentHTML,
                type: 'blue',
                icon: 'fas fa-link',
                closeIcon: true,
                animation: 'zoom',
                closeAnimation: 'scale',
                buttons: {
                    copiar: {
                        text: 'Copiar link',
                        btnClass: 'btn-primary',
                        action: function () {
                            navigator.clipboard.writeText(URL)
                            usedispatch(setToastes({ show: true, message: 'Link copiado al portapapeles', color: 'bg-success', estado: 'Copiado' }))
                            return false
                        }
                    },
                    abrir: {
                        text: 'Abrir link',
                        btnClass: 'btn-default',
                        action: function () {
                            window.open(URL, '_blank')
                        }
                    },
                    cerrar: {
                        text: 'Cerrar',
                        btnClass: 'btn-default',
                        action: function () { }
                    }
                },
                backgroundDismiss: true,
            });
            usedispatch(setModal({ nombre: '', estado: "" }))
            LimpiarLocalStore()
            Limpiarseleccion()
            LimpiarDescuentoVenta()
            usedispatch(clearMapa())
            detenervelocidad()
            return
        }
        // Resto de metodos (Tarjeta, PagoPlux, Stripe, PayPal) cuando quien
        // vende es un usuario logueado (panel interno): antes solo se hacia
        // window.open, sin ningun respaldo visible en la pagina -- si el
        // navegador bloqueaba el popup (comun, porque se dispara async
        // dentro de un .then, no del clic directo), no aparecia nada y no
        // habia forma de saber si el link se genero. Se reusa el mismo
        // modal con el link + boton de copiar/abrir que ya usa el flujo
        // publico (abrirLinkPasarela), asi el vendedor siempre ve el link.
        usedispatch(setModal({ nombre: '', estado: "" }))
        LimpiarLocalStore()
        Limpiarseleccion()
        LimpiarDescuentoVenta()
        usedispatch(clearMapa())
        detenervelocidad()
        abrirLinkPasarela(URL, metodo)
    }

    return (
        <>
            {alert}
            <Modal
                show={true}
                fullscreen={'md-down'}
            >
                <Modal.Header className=" d-flex  rounded-top-4   bg-dark pb-2
                 justify-content-between align-items-center">
                    <div className="d-flex flex-lg-row pb-2 container justify-content-between text-center" >
                        <h5 className=' text-white' style={{ fontWeight: "bold", fontSize: '1.37em' }}>{intervalo ? "Tiempo restante para la compra" : ""}  </h5>
                        <h5 style={{ fontWeight: "bold", fontSize: '1.7em' }}><span className=' text-danger' > {intervalo ? intervalo : ""} </span> </h5>
                        <div><button className='close text-light' onClick={closedeposito} >X</button></div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <SeccionFisicosVenta fisicos={fisicos} idLector="lector-fisico-link" />
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <div className='d-flex flex-column pb-3' style={{ textAlign: '', fontWeight: '' }}>
                            <h5 style={{ fontSize: '1.1em', textTransform: '' }}>Una vez realizado el pago los boletos seran enviados a:
                            </h5>
                            <span className=' pt-2' style={{ fontWeight: '', fontSize: '1.1em' }}>
                                {datosPerson.envio != "whatsapp" ? "Correo: " : "Whastapp: "}     <span>{datosPerson.envio != "whatsapp" ? datosPerson.email : datosPerson.whatsapp}</span>
                            </span>
                        </div>

                        {descuentosVend.length > 0 && (
                            <div className='pb-3'>
                                <h6 className='mb-2' style={{ fontSize: '1em', fontWeight: 700 }}>Descuento</h6>
                                <div className='form-check'>
                                    <input className='form-check-input' type='radio' name='descuentoVenta'
                                        id='descVenta-none' checked={descuentoSelId === null}
                                        onChange={() => elegirDescuento(null)} />
                                    <label className='form-check-label' htmlFor='descVenta-none'>Sin descuento</label>
                                </div>
                                {descuentosVend.map((d) => (
                                    <div className='form-check' key={d.id}>
                                        <input className='form-check-input' type='radio' name='descuentoVenta'
                                            id={`descVenta-${d.id}`} checked={descuentoSelId === d.id}
                                            onChange={() => elegirDescuento(d.id)} />
                                        <label className='form-check-label' htmlFor={`descVenta-${d.id}`}>
                                            {d.nombre} <strong>&minus;{Number(d.porcentaje)}%</strong>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        )}

                        {descuentosVend.length === 0 && descLinkPublico && (
                            <div className='pb-3'>
                                <div className='alert alert-success py-2 mb-0' style={{ fontSize: '0.95em' }}>
                                    🎉 <span style={{ whiteSpace: 'pre-line' }}>{descLinkPublico.mensaje_motivo
                                        ? descLinkPublico.mensaje_motivo
                                        : `Descuento de ${textoDescuento(descLinkPublico).replace(' de descuento', '')} aplicado`}</span>
                                </div>
                            </div>
                        )}

                        {totalConDescuentoTxt && (
                            <div className='pb-3' style={{ fontSize: '0.95em' }}>
                                Con el descuento el total será <strong>${totalConDescuentoTxt}</strong>.
                            </div>
                        )}

                        <label className='' htmlFor="pagoMedio"
                            style={{
                                textAlign: 'center',
                            }}
                        >
                            <div className='m-3 '>
                                <div className='px-0 pagos'
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        padding: '5px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={metodo == "Payphone" ? CrearPyhome : (metodo == "PagoPlux" || metodo == "Duna" || metodo == "Stripe" || metodo == "PayPal") ? CrearPagoMedio : undefined}
                                >
                                    {/**
                             *
                             * https://codigomarret.online/img/whatsapp image 2022-09-18 at 15.12.28.jpeg
                             */}
                                    {metodo == "Payphone" ? (
                                        <div style={{
                                            width: 420,
                                            maxWidth: '100%',
                                            borderRadius: 12,
                                            border: '1px solid #cfd9ff',
                                            background: '#fff',
                                            padding: '18px 10px',
                                            boxShadow: '0 2px 6px rgba(20,60,220,0.12)',
                                        }}>
                                            <div style={{
                                                fontSize: '1.8em',
                                                fontWeight: 800,
                                                letterSpacing: '-0.5px',
                                            }}>
                                                <span style={{ color: '#1436DC' }}>Pay</span>
                                                <span style={{ color: '#00C2A0' }}>phone</span>
                                            </div>
                                            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>
                                                Pago seguro con tarjeta
                                            </div>
                                        </div>
                                    ) : metodo == "PagoPlux" ? (
                                        <div style={{
                                            width: 420,
                                            maxWidth: '100%',
                                            borderRadius: 22,
                                            border: '2px solid #201A5B',
                                            background: '#fff',
                                            padding: '16px 22px',
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                flexWrap: 'wrap',
                                                rowGap: 4,
                                            }}>
                                                <div style={{ lineHeight: 0.95 }}>
                                                    <div style={{
                                                        fontSize: '1.05em',
                                                        fontWeight: 700,
                                                        color: '#F97316',
                                                        letterSpacing: '-0.3px',
                                                    }}>Pago</div>
                                                    <div style={{
                                                        fontSize: '1.7em',
                                                        fontWeight: 800,
                                                        color: '#6C2EB5',
                                                        letterSpacing: '-0.5px',
                                                    }}>Plux</div>
                                                </div>
                                                <div style={{
                                                    fontSize: '0.8em',
                                                    fontWeight: 700,
                                                    color: '#6C2EB5',
                                                    letterSpacing: '0.5px',
                                                    textTransform: 'uppercase',
                                                }}>Plataforma de pagos</div>
                                            </div>
                                            <div style={{
                                                marginTop: 12,
                                                paddingTop: 12,
                                                borderTop: '1px solid #eee',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-around',
                                                alignItems: 'center',
                                                columnGap: 14,
                                                rowGap: 8,
                                            }}>
                                                <span style={{ fontSize: '0.72em', fontWeight: 800, color: '#111', fontStyle: 'italic' }}>DISCOVER</span>
                                                <span style={{ fontSize: '0.78em', fontWeight: 800, color: '#1A1F71', fontStyle: 'italic' }}>VISA</span>
                                                <span style={{ fontSize: '0.72em', fontWeight: 800, color: '#2E77BC' }}>AMEX</span>
                                                <span style={{ fontSize: '0.62em', fontWeight: 700, color: '#003087', fontFamily: 'serif' }}>Diners Club</span>
                                                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                    <span style={{ width: 15, height: 15, borderRadius: '50%', background: '#EB001B', marginRight: -6 }}></span>
                                                    <span style={{ width: 15, height: 15, borderRadius: '50%', background: '#F79E1B', opacity: 0.9 }}></span>
                                                </span>
                                                <span style={{ fontSize: '0.68em', fontWeight: 800, color: '#005BAC' }}>UnionPay</span>
                                            </div>
                                        </div>
                                    ) : metodo == "Duna" ? (
                                        <div style={{
                                            width: 420,
                                            maxWidth: '100%',
                                            borderRadius: 12,
                                            border: '1px solid #cfe0d8',
                                            background: '#fff',
                                            padding: '18px 10px',
                                        }}>
                                            <img
                                                src="https://www.deuna.uanataca.ec/assets/images/deunalogo.png"
                                                alt="Deuna"
                                                style={{ maxWidth: 160, height: 'auto' }}
                                            />
                                            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>
                                                Pago seguro con Deuna
                                            </div>
                                            {clienteInfo() != null ? (
                                                <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #eee' }}
                                                    onClick={(e) => e.stopPropagation()}>
                                                    <div style={{ fontSize: '0.78em', color: '#666', marginBottom: 6 }}>
                                                        Deuna solo genera QR o link, no los dos -- elegí cuál generar:
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
                                                        <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.85em', cursor: 'pointer' }}>
                                                            <input type="radio" name="dunaModo" checked={dunaModo === 'qr'}
                                                                onChange={() => setDunaModo('qr')} />
                                                            Código QR
                                                        </label>
                                                        <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.85em', cursor: 'pointer' }}>
                                                            <input type="radio" name="dunaModo" checked={dunaModo === 'link'}
                                                                onChange={() => setDunaModo('link')} />
                                                            Link para copiar
                                                        </label>
                                                    </div>
                                                </div>
                                            ) : ""}
                                        </div>
                                    ) : metodo == "Stripe" ? (
                                        <div style={{
                                            width: 420,
                                            maxWidth: '100%',
                                            borderRadius: 12,
                                            border: '1px solid #cfd9ff',
                                            background: '#fff',
                                            padding: '18px 10px',
                                        }}>
                                            <div style={{
                                                fontSize: '1.6em',
                                                fontWeight: 800,
                                                letterSpacing: '-0.5px',
                                                color: '#635BFF',
                                            }}>
                                                stripe
                                            </div>
                                            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>
                                                Pago seguro con tarjeta
                                            </div>
                                        </div>
                                    ) : metodo == "PayPal" ? (
                                        <div style={{
                                            width: 420,
                                            maxWidth: '100%',
                                            borderRadius: 12,
                                            border: '1px solid #cfd9ff',
                                            background: '#fff',
                                            padding: '18px 10px',
                                        }}>
                                            <div style={{
                                                fontSize: '1.6em',
                                                fontWeight: 800,
                                                letterSpacing: '-0.5px',
                                            }}>
                                                <span style={{ color: '#003087' }}>Pay</span>
                                                <span style={{ color: '#0070BA' }}>Pal</span>
                                            </div>
                                            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>
                                                Pago seguro con PayPal
                                            </div>
                                        </div>
                                    ) : metodo == "Tarjeta" ? (
                                        <div style={{
                                            width: 420,
                                            maxWidth: '100%',
                                            borderRadius: 12,
                                            border: '1px solid #cfd9ff',
                                            background: '#fff',
                                            padding: '18px 14px',
                                        }}>
                                            <div style={{ fontWeight: 700, marginBottom: 10 }}>
                                                Elige con qué plataforma pagar
                                            </div>
                                            {gatewaysActivos === null ? (
                                                <span style={{ color: '#666' }}>Cargando métodos disponibles...</span>
                                            ) : gatewaysActivos.length === 0 ? (
                                                <span style={{ color: '#a33' }}>No hay ninguna plataforma de pago activa. Contacta al administrador.</span>
                                            ) : (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
                                                    {gatewaysActivos.includes("PagoPlux") ?
                                                        <button type='button' className='btn btn-outline-primary' onClick={() => elegirGateway("PagoPlux")}>PagoPlux</button> : ""}
                                                    {gatewaysActivos.includes("Payphone") ?
                                                        <button type='button' className='btn btn-outline-primary' onClick={() => elegirGateway("Payphone")}>Payphone</button> : ""}
                                                    {gatewaysActivos.includes("Duna") ?
                                                        <button type='button' className='btn btn-outline-primary' onClick={() => elegirGateway("Duna")}>Duna</button> : ""}
                                                    {gatewaysActivos.includes("Stripe") ?
                                                        <button type='button' className='btn btn-outline-primary' onClick={() => elegirGateway("Stripe")}>Stripe</button> : ""}
                                                    {gatewaysActivos.includes("PayPal") ?
                                                        <button type='button' className='btn btn-outline-primary' onClick={() => elegirGateway("PayPal")}>PayPal</button> : ""}
                                                    {gatewaysActivos.includes("Abitmedia") ?
                                                        <button type='button' className='btn btn-outline-primary' onClick={CrearPagoMedio}>Tarjeta de crédito</button> : ""}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div style={{
                                            width: 420,
                                            maxWidth: '100%',
                                            borderRadius: 12,
                                            border: '1px solid #f1c0c0',
                                            background: '#fff8f8',
                                            padding: '18px 10px',
                                            color: '#a33',
                                        }}>
                                            Selecciona un método de pago válido para continuar.
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='m-3 d-none'>
                                <div className='px-0 pagos' style={{
                                    display: 'flex',
                                    alignItems: "start",
                                    padding: '5px',
                                    cursor: 'pointer'
                                }}
                                    onClick={CrearPagoMedio}
                                >
                                    <img src={diners}
                                        height={50} />
                                </div>


                            </div>
                            <div className='m-3 d-none'>
                                <div className='px-0 pagos' style={{
                                    display: 'flex',
                                    alignItems: "start",

                                    padding: '5px',
                                    cursor: 'pointer'

                                }}
                                    onClick={CrearPyhome}
                                >
                                    <img src={visas}
                                        height={50}

                                    />
                                </div>
                            </div>
                            <div className='m-3 d-none'>
                                <div className='px-0 pagos' style={{
                                    display: 'flex',
                                    alignItems: "start",

                                    padding: '5px',
                                    cursor: 'pointer'
                                }}>
                                    <img src={paypal}
                                        height={50} />
                                </div>


                            </div>
                            <div className='m-3 d-none'>
                                <div className='px-0 pagos '
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        padding: '5px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={CrearPyhome}
                                >
                                    {/**
                             * 
                             * https://codigomarret.online/img/whatsapp image 2022-09-18 at 15.12.28.jpeg
                             */}
                                    <img className=' image-fluid  '
                                        src={metodo == "Duna" ? Dunas : Pagos}
                                        width={420}
                                        alt="Pagos medios"
                                    />
                                </div>
                            </div>
                        </label>
                        <div className='d-flex  justify-content-center'>
                            <div className=' container d-flex   px-0 mx-0 justify-content-between text-center ' style={{ width: '90%' }}>
                                <div className='d-none px-'>
                                    <button className='btn btn-primary btn-lg   ' style={{ fontSize: '' }} onClick={CrearPagoMedio}  >  SEGUIR
                                        <span className='  text-primary '></span>
                                    </button>

                                </div>
                                <div className='col-12 text-center'>
                                    <button className='btn  btn-outline-danger btn-lg ' style={{ fontSize: '' }} onClick={succesAlert}> ELIMINAR COMPRA </button>
                                </div>
                            </div>
                        </div>

                        <div className=' d-none'
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'flex-end',
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <div>
                                <button type="button" className='btn btn-primary btn-lg'
                                >


                                </button>
                            </div>

                            <button className='btn  btn-outline-primary btn-sm'

                                onClick={succesAlert}
                            >CANCELAR</button>
                        </div>
                        <div>
                            <div className={spinerst}
                                style={{
                                    display: 'none',
                                    position: 'fixed',
                                    top: '0',
                                    left: '0',
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    zIndex: '1000'
                                }}
                            >

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '10px',
                                    padding: '10px',
                                }}>
                                    <Spinner animation="border" variant="light" size='120'></Spinner>
                                    <h4 className='text-light'>Generando Link de Pago</h4>
                                    <h4 className='text-light'>...</h4>
                                    <h4 className='text-light'>Esto puede tardar algunos minutos</h4>

                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>
            <div className='d-none'
                style={{
                    display: 'none',
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: '1000'
                }}
            >
                {alert}
                <div
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        padding: '20px',
                        alignItems: 'center',
                    }}
                >
                    <div className='d-flex h-25 bg-azul1'>

                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        border: '3px solid #000000',
                        borderRadius: '10px',
                        padding: '10px',
                    }}>

                        <div className='d-flex justify-content-end'>
                            <button className='btn btn-primary' onClick={closedeposito} > <i className="bi bi-caret-left-fill"></i>  Regresar  </button>
                        </div>
                        <div className='d-flex flex-column pb-3' style={{ textAlign: 'center', fontWeight: 'bold' }}>
                            <h6 style={{ fontWeight: "bold", fontSize: '1.2em' }}>{intervalo ? "Tiempo restante" : ""} <span className=' text-secondary ' > {intervalo ? intervalo : ""} </span>  </h6>
                            <strong>
                                <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Una vez confirmado el pago se enviara los boletos a :
                                </span>

                            </strong>
                            <strong>
                                <span className='text-primary pt-2' style={{ fontWeight: 'bold', fontSize: '1.4em' }}>
                                    {datosPerson.envio != "whatsapp" ? datosPerson.email : datosPerson.whatsapp}

                                </span></strong>
                        </div>

                        {/* //PAGO CON PAGO MEDIO */}
                        <label className='pt-3' htmlFor="pagoMedio"
                            style={{
                                textAlign: 'center',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '10px',
                                    cursor: 'pointer'
                                }}
                                onClick={CrearPagoMedio}
                            >
                                {/**
                             * 
                             * https://codigomarret.online/img/whatsapp image 2022-09-18 at 15.12.28.jpeg
                             */}
                                <img
                                    src={Pagos}
                                    width={340}
                                    alt="Pagos medios"
                                />
                            </div>
                        </label>


                        {/* //PAGO CON PAYPHONE */}
                        {/*<label htmlFor="payPhone"
                        style={{
                            textAlign: 'center',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '10px',
                                cursor: 'pointer'
                            }}
                            onClick={() => CrearLinkPayPhone()}
                        >
                            <img
                                src="https://codigomarret.online/img/payphone.jpeg"
                                width={300}
                                alt="Pagos medios"
                            />
                        </div>
                        {/* 
                    <ButtonPago cargar={cargar} /> }
                    </label> */}


                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-end',
                                alignItems: 'flex-end',
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <button className='btn btn-primary text-white'
                                style={{
                                    border: 'none',
                                    borderRadius: '10px',
                                    padding: '10px',

                                }}
                                onClick={succesAlert}
                            >Cancelar</button>
                        </div>

                    </div>
                </div>
                <div>
                    <div className={""}
                        style={{
                            display: 'none',
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: '1000'
                        }}
                    >

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '10px',
                            padding: '10px',
                        }}>
                            <Spinner animation="border" variant="light" size='120'></Spinner>
                            <h4 className='text-light'>Generando Link de Pago</h4>
                            <h4 className='text-light'>...</h4>
                            <h4 className='text-light'>Esto puede tardar algunos minutos</h4>


                        </div>
                    </div>
                </div>

                {/* {
                estadoFrame ?
                    <Iframe
                        setEstadoFrame={setEstadoFrame}
                        url={url}
                    />
                    : null

            } */}
            </div>
        </>
    );
}


export default ModalPago;